<template>
  <div v-if="toast" class="rd-toast" role="status">
    {{ toast.text }}
    <button v-if="toast.action" type="button" @click="$emit('action')">{{ toast.label }}</button>
  </div>
</template>

<script>
/** Kratko obaveštenje na dnu izveštaja, sa opcionom radnjom (npr. "Poništi"). */
export default {
  name: "ReportToast",
  props: {
    /** { text, label, action } ili null */
    toast: { type: Object, default: null },
  },
};
</script>
